import { createIcon } from "@chakra-ui/react";
import React from "react";

const IconAdobe = createIcon({
  displayName: "IconAdobe",
  viewBox: "0 0 150 150.2",
  path: (
    <>
      <path d="M0 .2h150v150H0V.2z" fill="none" />

      <path
        fill="#EC2227"
        d="M92.5 18.1l46.7 111.8V18.1zM13 18.1v111.8L59.7 18.1zM55.7 107.4h21.8l8.9 22.5h19.4L76.1 59.3z"
      />
    </>
  ),
});

export default IconAdobe;
